"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
class User {
    constructor(data) {
        this.id = null;
        this.name = null;
        this.nickname = null;
        this.email = null;
        this.title = null;
        this.rpps = null;
        this.roles = [];
        this.profession = null;
        this.specialty = null;
        this.country = null;
        this.lastLogin = null;
        this.lastConsumed = null;
        this.updatedAt = null;
        this.feeds = [];
        this.area = null;
        this.zipcode = null;
        this.uga = null;
        this.workplace = null;
        this.pushId = null;
        this.confirmationToken = null;
        if (data) {
            this.id = data.id || null;
            this.name = data.name || null;
            this.nickname = data.nickname || null;
            this.email = data.email || null;
            this.title = data.title || null;
            this.rpps = data.rpps || null;
            this.roles = data.roles || [];
            this.profession = data.profession || null;
            this.specialty = data.specialty || null;
            this.country = data.country || null;
            this.area = data.area || null;
            this.zipcode = data.zipcode || null;
            this.uga = data.uga || null;
            this.workplace = data.workplace || null;
            this.lastLogin = data.lastLogin || null;
            this.updatedAt = data.updatedAt || null;
            this.pushId = data.pushId || null;
            this.confirmationToken = data.confirmationToken || null;
            this.feeds = (typeof data.feeds !== "undefined") ? data.feeds : [];
        }
    }
    toJson() {
        return {
            id: this.id,
            name: this.name,
        };
    }
}
exports.User = User;
User.EDITABLE_FIELDS = ['name', 'nickname', 'pushId'];
//# sourceMappingURL=User.js.map